import { RuleNodeV2Data } from "src/constants/NodeDataTypes";
import { SearchableField } from "src/flowGraph/canvasSearch/extractNodeFields";
import { extractClauses } from "src/flowGraph/canvasSearch/nodesExtractors/utils";

export const extractRuleNodeFields = (
  data: RuleNodeV2Data,
): SearchableField[] => {
  const searchableDefaultEffectTargets = data.default_effects.map(
    ({ id, target }) => ({
      id: `${id}:target`,
      value: `data.${target}`,
    }),
  );

  const searchableBranches = data.branches.flatMap(({ clauses, effects }) => {
    const searchableClauses = extractClauses(clauses);

    const searchableEffects = effects.map(({ id, value }) => ({
      id,
      value,
    }));

    return [...searchableClauses, ...searchableEffects];
  });

  const searchableDefaultEffectValues = data.default_effects.map(
    ({ id, value }) => ({
      id: `${id}:value`,
      value,
    }),
  );

  return [
    ...searchableDefaultEffectTargets,
    ...searchableBranches,
    ...searchableDefaultEffectValues,
  ];
};
